import api from "../api/api";

// GET semua transportations
export const getAllTransportations = async () => {
  const res = await api.get("/transportations");
  return res.data.data; // sesuaikan jika struktur respons berbeda
};

// CREATE transportation baru
export const createTransportation = async (payload) => {
  const res = await api.post("/transportations", payload);
  return res.data;
};

// UPDATE transportation berdasarkan ID
export const updateTransportation = async (id, payload) => {
  const res = await api.put(`/transportations/${id}`, payload);
  return res.data;
};

// services/transportationsServices.js
export const getTransportationByVehicleNumber = async (vehicleNumber) => {
  const res = await api.get(`/transportations/${vehicleNumber}`);
  return res.data.data; // sudah object, tidak perlu [0]
};

// DELETE transportation berdasarkan ID
export const deleteTransportation = async (id) => {
  const res = await api.delete(`/transportations/${id}`);
  return res.data;
};
